module.exports = __webpack_public_path__ + "assets/img/lunt.b54a38cd.png";